import { useAccountStore } from '@/store/modules/account/store.js';

export default {
    authUser: (state) =>
        state.parentAuthUser?.childUserForAccount(useAccountStore().contextAccount?.id) ||
        state.parentAuthUser,
    session: (state) => state.parentAuthUser?.session,

    getUsers:
        (state) =>
        (accountId = null) => {
            if (!accountId) {
                return Object.values(state.users);
            }

            return Object.values(state.users)
                .filter((user) => user.account_id === accountId)
                .sort((a, b) => a.fullName.localeCompare(b.fullName));
        },

    getActiveUsers:
        (state) =>
        (accountId = null) => {
            return state.getUsers(accountId).filter((user) => user.isSelectable);
        },

    getAdvisorUsers:
        (state) =>
        (accountId = null) => {
            return state
                .getUsers(accountId)
                .filter((user) => user.isSelectable && (user.isAdvisor() || user.isDirector()));
        },

    getBdcUsers:
        (state) =>
        (accountId = null) => {
            return state
                .getUsers(accountId)
                .filter(
                    (user) =>
                        user.isSelectable &&
                        (user.isBdc() || user.isBdcDirector() || user.isDirector())
                );
        },

    getCommercialUsers:
        (state) =>
        (accountId = null) => {
            return state
                .getUsers(accountId)
                .filter(
                    (user) =>
                        user.isSelectable && (user.isCommercialDirector() || user.isDirector())
                );
        },

    getDirectorUsers:
        (state) =>
        (accountId = null) => {
            return state
                .getUsers(accountId)
                .filter((user) => user.isSelectable && user.isDirector());
        },

    getServiceAdvisorUsers:
        (state) =>
        (accountId = null) => {
            return state
                .getUsers(accountId)
                .filter(
                    (user) =>
                        user.isSelectable && (user.isServiceAdvisor() || user.isServiceDirector())
                );
        },

    getServiceAgentUsers:
        (state) =>
        (accountId = null) => {
            return state
                .getUsers(accountId)
                .filter(
                    (user) =>
                        user.isSelectable && (user.isServiceAgent() || user.isServiceDirector())
                );
        },
};
